import $ from 'jquery';
import { initializeSelect2, initializeSelect2FromAjax } from '../initialize-select2';
export function runDriverAutofill(event) {
    event.preventDefault();
    let insured_fiscal_code = $('input[name="insured_fiscal_code"]').val();
    let insured_name = $('input[name="insured_name"]').val();
    let insured_last_name = $('input[name="insured_last_name"]').val();
    let insured_country = $('select[name="insured_country"]').val();
    let insured_provincia = $('select[name="insured_provincia"]').val();
    let insured_city = $('select[name="insured_city"]').val();
    let insured_address = $('input[name="insured_address"]').val();
    let insured_zip = $('input[name="insured_cap"]').val();
    let insured_comune_istat = $('input[name="insured_city_istat"]').val();
    let insured_area = $('input[name="insured_area"]').val();

    $('input[name="driver_fiscal_code"]').val(insured_fiscal_code);
    $('input[name="driver_birthdate"]').val($('input[name="insured_birthdate"]').val());
    $('input[name="driver_name"]').val(insured_name);
    $('input[name="driver_last_name"]').val(insured_last_name);
    $('select[name="driver_country"]').val(insured_country).trigger('change');
    $('select[name="driver_provincia"]').val(insured_provincia).trigger('change');
    $('input[name="driver_address"]').val(insured_address);
    $('input[name="driver_cap"]').val(insured_zip);
    $('input[name="driver_comune_istat"]').val(insured_comune_istat);
    $('input[name="driver_area"]').val(insured_area);
    $('input[name="driver_telephone"]').val($('input[name="owner_telephone"]').val());
    $('input[name="driver_email"]').val($('input[name="owner_email"]').val());
    $('input[name="driver"]').val($('input[name="insured"]').val());

    initializeSelect2($('select[name="driver_country"]'), insured_country);
    initializeSelect2($('select[name="driver_provincia"]'), insured_provincia);
    if (insured_city !== undefined && insured_city !== null && insured_city.length > 0) {
        initializeSelect2FromAjax($('select[name="driver_comune"]'), insured_city, insured_city.toUpperCase());
    }
}
export function runOtherDriverAutofill(event) {
    event.preventDefault();
    let other_insured_fiscal_code = $('input[name="other_insured_fiscal_code"]').val();
    let other_insured_name = $('input[name="other_insured_name"]').val();
    let other_insured_last_name = $('input[name="other_insured_last_name"]').val();
    let other_insured_country = $('select[name="other_insured_country"]').val();
    let other_insured_provincia = $('select[name="other_insured_provincia"]').val();
    let other_insured_city = $('select[name="other_insured_comune"]').val();
    let other_insured_address = $('input[name="other_insured_address"]').val();
    let other_insured_zip = $('input[name="other_insured_cap"]').val();
    let other_insured_comune_istat = $('input[name="other_insured_comune_istat"]').val();
    let other_insured_area = $('input[name="other_insured_area"]').val();

    $('input[name="other_driver_fiscal_code"]').val(other_insured_fiscal_code);
    $('input[name="other_driver_birthdate"]').val($('input[name="other_insured_birthdate"]').val());
    $('input[name="other_driver_name"]').val(other_insured_name);
    $('input[name="other_driver_last_name"]').val(other_insured_last_name);
    $('select[name="other_driver_country"]').val(other_insured_country).trigger('change');
    $('select[name="other_driver_provincia"]').val(other_insured_provincia).trigger('change');
    $('input[name="other_driver_address"]').val(other_insured_address);
    $('input[name="other_driver_cap"]').val(other_insured_zip);
    $('input[name="other_driver_comune_istat"]').val(other_insured_comune_istat);
    $('input[name="other_driver_area"]').val(other_insured_area);
    $('input[name="other_driver_telephone"]').val($('input[name="other_insured_telephone"]').val());
    $('input[name="other_driver_email"]').val($('input[name="other_insured_email"]').val());
    $('input[name="other_driver"]').val($('input[name="other_insured"]').val());

    initializeSelect2($('select[name="other_driver_country"]'), other_insured_country);
    initializeSelect2($('select[name="other_driver_provincia"]'), other_insured_provincia);
    if (other_insured_city !== undefined && other_insured_city !== null && other_insured_city.length > 0) {
        initializeSelect2FromAjax($('select[name="other_driver_comune"]'), other_insured_city, other_insured_city.toUpperCase());
    }
}
export function updateOtherInsuredFullName() {
    let lastName = $('input[name="other_insured_last_name"]').val();
    let firstName = $('input[name="other_insured_name"]').val();
    let fullName = `${lastName} ${firstName}`.trim();
    $('input[name="other_insured"]').val(fullName);
}
export function updateInsuredFullName() {
    let lastName = $('input[name="insured_last_name"]').val();
    let firstName = $('input[name="insured_name"]').val();
    let fullName = `${lastName} ${firstName}`.trim();
    $('input[name="insured"]').val(fullName);
}
export function updateDriverFullName() {
    let lastName = $('input[name="driver_last_name"]').val();
    let firstName = $('input[name="driver_name"]').val();
    let fullName = `${lastName} ${firstName}`.trim();
    $('input[name="driver"]').val(fullName);
}

export function updateOtherDriverFullName() {
    let lastName = $('input[name="other_driver_last_name"]').val();
    let firstName = $('input[name="other_driver_name"]').val();
    let fullName = `${lastName} ${firstName}`.trim();
    $('input[name="other_driver"]').val(fullName);
}

export function runCopyInsuredToOwner(event) {
    if (event) {
        event.preventDefault();
    }
    let insured = $('[name="insured"]').val();
    let insuredId = $('[name="insured_id"]').val();
    let insuredLastName = $('[name="insured_last_name"]').val();
    let insuredName = $('[name="insured_name"]').val();
    let insuredBirthdate = $('[name="insured_birthdate"]').val();
    let insuredFiscalCode = $('[name="insured_fiscal_code"]').val();
    let insuredComune = $('[name="insured_comune"]').val();
    let insuredComuneText = $('[name="insured_comune_text"]').val();
    let insuredComuneLabel = $('[name="insured_comune"] option:selected').text();
    let insuredComuneIstat = $('[name="insured_comune_istat"]').val();
    let insuredProvincia = $('[name="insured_provincia"]').val();
    let plateCountry = $('[name="plate_country"]').val();
    let insuredArea = $('[name="insured_area"]').val();
    let insuredCap = $('[name="insured_cap"]').val();
    let insuredAddress = $('[name="insured_address"]').val();
    let insuredCountry = $('[name="insured_country"]').val();
    let insuredTelephone = $('[name="insured_telephone"]').val();
    let insuredEmail = $('[name="insured_email"]').val();
    let plateType = $('[name="plate_type"]').val();
    let insuredGuilty = $('[name="insured_guilty"]').is(':checked');
    let resignRecourse = $('[name="resign_recourse"]').is(':checked');
    let insuredParked = $('[name="insured_parked"]').is(':checked');
    let veichleType = $('[name="veichle_type"]').val();
    let insuredDamageVehicle = $('[name="insured_damage_vehicle"]').is(':checked');
    let insuredDamageThing = $('[name="insured_damage_thing"]').is(':checked');
    let insuredDamagePerson = $('[name="insured_damage_person"]').is(':checked');

    $('[name="owner"]').val(insured);
    $('[name="owner_id"]').val(insuredId);
    $('[name="owner_last_name"]').val(insuredLastName);
    $('[name="owner_name"]').val(insuredName);
    $('[name="owner_birthdate"]').val(insuredBirthdate);
    $('[name="owner_fiscal_code"]').val(insuredFiscalCode);
    $('[name="owner_country"]').val(insuredCountry);
    $('[name="owner_provincia"]').val(insuredProvincia);
    let ownerComune = $('[name="owner_comune"]');

    // Make sure Select2 is initialized
    let newOption = new Option(insuredComuneLabel, insuredComune, true, true);
    ownerComune.append(newOption).trigger("change.select2");

    // Update ISTAT field
    $('[name="owner_comune_istat"]').val(insuredComuneIstat);
    $('[name="owner_comune_text"]').val(insuredComuneText);
    $('[name="owner_cap"]').val(insuredCap);
    $('[name="owner_address"]').val(insuredAddress);
    $('[name="owner_telephone"]').val(insuredTelephone);
    $('[name="owner_email"]').val(insuredEmail);
    $('[name="owner_damage_vehicle"]').prop('checked', insuredDamageVehicle);
    $('[name="owner_damage_thing"]').prop('checked', insuredDamageThing);
    $('[name="owner_damage_person"]').prop('checked', insuredDamagePerson);
    $('[name="owner_city"]').val(insuredComune);
    $('[name="owner_area"]').val(insuredArea);
}

export function runCopyInsuredToDriver(event) {
    if (event) {
        event.preventDefault();
    }
    let insured = $('[name="insured"]').val();
    let insuredId = $('[name="insured_id"]').val();
    let insuredLastName = $('[name="insured_last_name"]').val();
    let insuredName = $('[name="insured_name"]').val();
    let insuredBirthdate = $('[name="insured_birthdate"]').val();
    let insuredFiscalCode = $('[name="insured_fiscal_code"]').val();
    let insuredComune = $('[name="insured_comune"]').val();
    let insuredComuneIstat = $('[name="insured_comune_istat"]').val();
    let insuredProvincia = $('[name="insured_provincia"]').val();
    let plateCountry = $('[name="plate_country"]').val();
    let insuredArea = $('[name="insured_area"]').val();
    let insuredCap = $('[name="insured_cap"]').val();
    let insuredAddress = $('[name="insured_address"]').val();
    let insuredCountry = $('[name="insured_country"]').val();
    let insuredTelephone = $('[name="insured_telephone"]').val();
    let insuredEmail = $('[name="insured_email"]').val();
    let plateType = $('[name="plate_type"]').val();
    let insuredGuilty = $('[name="insured_guilty"]').is(':checked');
    let resignRecourse = $('[name="resign_recourse"]').is(':checked');
    let insuredParked = $('[name="insured_parked"]').is(':checked');
    let veichleType = $('[name="veichle_type"]').val();
    let insuredDamageVehicle = $('[name="insured_damage_vehicle"]').is(':checked');
    let insuredDamageThing = $('[name="insured_damage_thing"]').is(':checked');
    let insuredDamagePerson = $('[name="insured_damage_person"]').is(':checked');

    $('[name="driver"]').val(insured);
    $('[name="driver_id"]').val(insuredId);
    $('[name="driver_last_name"]').val(insuredLastName);
    $('[name="driver_name"]').val(insuredName);
    $('[name="driver_birthdate"]').val(insuredBirthdate);
    $('[name="driver_fiscal_code"]').val(insuredFiscalCode);
    $('[name="driver_provincia"]').val(insuredProvincia);
    $('[name="driver_comune"]').val(insuredComune);
    $('[name="driver_comune_istat"]').val(insuredComuneIstat);
    $('[name="driver_telephone"]').val(insuredTelephone);
    $('[name="driver_email"]').val(insuredEmail);
    $('[name="driver_damage_vehicle"]').prop('checked', insuredDamageVehicle);
    $('[name="driver_damage_thing"]').prop('checked', insuredDamageThing);
    $('[name="driver_damage_person"]').prop('checked', insuredDamagePerson);
    $('[name="driver_city"]').val(insuredComune);
    $('[name="driver_area"]').val(insuredArea);
    $('[name="driver_country"]').val(insuredCountry);
    $('[name="driver_cap"]').val(insuredCap);
    $('[name="driver_address"]').val(insuredAddress);
}

export function runCopyOtherInsuredToOtherDriver(event) {
    if (event) {
        event.preventDefault();
    }
    let insuredId = $('[name="other_insured_id"]').val();
    let insuredLastName = $('[name="other_insured_last_name"]').val();
    let insuredName = $('[name="other_insured_name"]').val();
    let insuredBirthdate = $('[name="other_insured_birthdate"]').val();
    let insuredFiscalCode = $('[name="other_insured_fiscal_code"]').val();
    let insuredComune = $('[name="other_insured_comune"]').val();
    let insuredComuneIstat = $('[name="other_insured_comune_istat"]').val();
    let insuredProvincia = $('[name="other_insured_provincia"]').val();
    let plateCountry = $('[name="other_plate_country"]').val();
    let insuredArea = $('[name="other_insured_area"]').val();
    let insuredCap = $('[name="other_insured_cap"]').val();
    let insuredAddress = $('[name="other_insured_address"]').val();
    let insuredCountry = $('[name="other_insured_country"]').val();
    let insuredTelephone = $('[name="other_insured_telephone"]').val();
    let insuredEmail = $('[name="other_insured_email"]').val();
    let plateType = $('[name="other_plate_type"]').val();
    let insuredGuilty = $('[name="other_insured_guilty"]').is(':checked');
    let resignRecourse = $('[name="other_resign_recourse"]').is(':checked');
    let insuredParked = $('[name="other_insured_parked"]').is(':checked');
    let veichleType = $('[name="other_veichle_type"]').val();
    let insuredDamageVehicle = $('[name="other_insured_damage_vehicle"]').is(':checked');
    let insuredDamageThing = $('[name="other_insured_damage_thing"]').is(':checked');
    let insuredDamagePerson = $('[name="other_insured_damage_person"]').is(':checked');

    $('[name="other_driver_last_name"]').val(insuredLastName);
    $('[name="other_driver_name"]').val(insuredName);
    $('[name="other_driver_birthdate"]').val(insuredBirthdate);
    $('[name="other_driver_fiscal_code"]').val(insuredFiscalCode);
    $('[name="other_driver_provincia"]').val(insuredProvincia);
    $('[name="other_driver_comune"]').val(insuredComune);
    $('[name="other_driver_comune_istat"]').val(insuredComuneIstat);
    $('[name="other_driver_telephone"]').val(insuredTelephone);
    $('[name="other_driver_email"]').val(insuredEmail);
    $('[name="other_driver_damage_vehicle"]').prop('checked', insuredDamageVehicle);
    $('[name="other_driver_damage_thing"]').prop('checked', insuredDamageThing);
    $('[name="other_driver_damage_person"]').prop('checked', insuredDamagePerson);
    $('[name="other_driver_city"]').val(insuredComune);
    $('[name="other_driver_area"]').val(insuredArea);
    $('[name="other_driver_country"]').val(insuredCountry);
    $('[name="other_driver_cap"]').val(insuredCap);
    $('[name="other_driver_address"]').val(insuredAddress);
}

export function runCopyOtherInsuredToOtherOwner(event) {
    if (event) {
        event.preventDefault();
    }
    let insuredId = $('[name="other_insured_id"]').val();
    let insuredLastName = $('[name="other_insured_last_name"]').val();
    let insuredName = $('[name="other_insured_name"]').val();
    let insuredBirthdate = $('[name="other_insured_birthdate"]').val();
    let insuredFiscalCode = $('[name="other_insured_fiscal_code"]').val();
    let insuredComune = $('[name="other_insured_comune"]').val();
    let insuredComuneIstat = $('[name="other_insured_comune_istat"]').val();
    let insuredProvincia = $('[name="other_insured_provincia"]').val();
    let plateCountry = $('[name="other_plate_country"]').val();
    let insuredArea = $('[name="other_insured_area"]').val();
    let insuredCap = $('[name="other_insured_cap"]').val();
    let insuredAddress = $('[name="other_insured_address"]').val();
    let insuredCountry = $('[name="other_insured_country"]').val();
    let insuredTelephone = $('[name="other_insured_telephone"]').val();
    let insuredEmail = $('[name="other_insured_email"]').val();
    let plateType = $('[name="other_plate_type"]').val();
    let insuredGuilty = $('[name="other_insured_guilty"]').is(':checked');
    let resignRecourse = $('[name="other_resign_recourse"]').is(':checked');
    let insuredParked = $('[name="other_insured_parked"]').is(':checked');
    let veichleType = $('[name="other_veichle_type"]').val();
    let insuredDamageVehicle = $('[name="other_insured_damage_vehicle"]').is(':checked');
    let insuredDamageThing = $('[name="other_insured_damage_thing"]').is(':checked');
    let insuredDamagePerson = $('[name="other_insured_damage_person"]').is(':checked');

    $('[name="other_owner_last_name"]').val(insuredLastName);
    $('[name="other_owner_name"]').val(insuredName);
    $('[name="other_owner_birthdate"]').val(insuredBirthdate);
    $('[name="other_owner_fiscal_code"]').val(insuredFiscalCode);
    $('[name="other_owner_provincia"]').val(insuredProvincia);
    $('[name="other_owner_comune"]').val(insuredComune).trigger('change');
    $('[name="other_owner_comune_istat"]').val(insuredComuneIstat);
    $('[name="other_owner_telephone"]').val(insuredTelephone);
    $('[name="other_owner_email"]').val(insuredEmail);
    $('[name="other_owner_damage_vehicle"]').prop('checked', insuredDamageVehicle);
    $('[name="other_owner_damage_thing"]').prop('checked', insuredDamageThing);
    $('[name="other_owner_damage_person"]').prop('checked', insuredDamagePerson);
    $('[name="other_owner_city"]').val(insuredComune);
    $('[name="other_owner_area"]').val(insuredArea);
    $('[name="other_owner_country"]').val(insuredCountry);
    $('[name="other_owner_cap"]').val(insuredCap);
    $('[name="other_owner_address"]').val(insuredAddress);

}

export function runOwnerAutofill(event) {
    event.preventDefault();
    let insured_fiscal_code = $('input[name="insured_fiscal_code"]').val();
    let insured_name = $('input[name="insured_name"]').val();
    let insured_last_name = $('input[name="insured_last_name"]').val();
    let insured_country = $('select[name="insured_country"]').val();
    let insured_provincia = $('select[name="insured_provincia"]').val();
    let insured_city = $('select[name="insured_city"]').val();
    let insured_address = $('input[name="insured_address"]').val();
    let insured_zip = $('input[name="insured_cap"]').val();
    let insured_comune_istat = $('input[name="insured_city_istat"]').val();
    let insured_area = $('input[name="insured_area"]').val();

    $('input[name="owner_fiscal_code"]').val(insured_fiscal_code);
    $('input[name="owner_name"]').val(insured_name);
    $('input[name="owner_last_name"]').val(insured_last_name);
    $('select[name="owner_country"]').val(insured_country).trigger('change');
    $('select[name="owner_provincia"]').val(insured_provincia).trigger('change');
    $('input[name="owner_address"]').val(insured_address);
    $('input[name="owner_cap"]').val(insured_zip);
    $('input[name="owner_city_istat"]').val(insured_comune_istat);
    $('input[name="owner_area"]').val(insured_area);
    initializeSelect2($('select[name="owner_country"]'), insured_country);
    initializeSelect2($('select[name="owner_provincia"]'), insured_provincia);

    if (insured_city !== undefined && insured_city !== null && insured_city.length > 0) {
        initializeSelect2FromAjax($('select[name="owner_comune"]'), insured_city, insured_city.toUpperCase());
    }
}
export function runVehicleAutofill(event) {
    event.preventDefault();
    let insured_country = $('select[name="insured_country"]').val();
    let insured_provincia = $('select[name="insured_provincia"]').val();
    let insured_city = $('select[name="insured_city"]').val();
    let insured_address = $('input[name="insured_address"]').val();
    let insured_zip = $('input[name="insured_cap"]').val();
    let insured_comune_istat = $('input[name="insured_city_istat"]').val();
    let insured_area = $('input[name="insured_area"]').val();

    $('input[name="vehicle_country"]').val(insured_country).trigger('change');
    $('input[name="vehicle_provincia"]').val(insured_provincia).trigger('change');
    $('input[name="vehicle_address"]').val(insured_address);
    $('input[name="vehicle_cap"]').val(insured_zip);
    $('input[name="vehicle_city_istat"]').val(insured_comune_istat);
    $('input[name="vehicle_area"]').val(insured_area);
    $('input[name="vehicle_telephone"]').val($('input[name="insured_telephone"]').val());
    $('input[name="vehicle_email"]').val($('input[name="insured_email"]').val());
    initializeSelect2($('select[name="vehicle_country"]'), insured_country);
    initializeSelect2($('select[name="vehicle_provincia"]'), insured_provincia);
    if (insured_city !== undefined && insured_city !== null && insured_city.length > 0) {
        initializeSelect2FromAjax($('select[name="vehicle_city"]'), insured_city, insured_city.toUpperCase());
    }
}

export function runOtherOwnerAutofill(event) {
    event.preventDefault();
    let other_insured_fiscal_code = $('input[name="other_insured_fiscal_code"]').val();
    let other_insured_name = $('input[name="other_insured_name"]').val();
    let other_insured_last_name = $('input[name="other_insured_last_name"]').val();
    let other_insured_country = $('select[name="other_insured_country"]').val();
    let other_insured_provincia = $('select[name="other_insured_provincia"]').val();
    let other_insured_city = $('select[name="other_insured_comune"]').val();
    let other_insured_address = $('input[name="other_insured_address"]').val();
    let other_insured_zip = $('input[name="other_insured_cap"]').val();
    let other_insured_comune_istat = $('input[name="other_insured_comune_istat"]').val();
    let other_insured_area = $('input[name="other_insured_area"]').val();

    $('input[name="other_owner_fiscal_code"]').val(other_insured_fiscal_code);
    $('input[name="other_owner_name"]').val(other_insured_name);
    $('input[name="other_owner_last_name"]').val(other_insured_last_name);
    $('select[name="other_owner_country"]').val(other_insured_country).trigger('change');
    $('select[name="other_owner_provincia"]').val(other_insured_provincia).trigger('change');
    $('input[name="other_owner_address"]').val(other_insured_address);
    $('input[name="other_owner_cap"]').val(other_insured_zip);
    $('input[name="other_owner_comune_istat"]').val(other_insured_comune_istat);
    $('input[name="other_owner_area"]').val(other_insured_area);
    initializeSelect2($('select[name="other_owner_country"]'), other_insured_country);
    initializeSelect2($('select[name="other_owner_provincia"]'), other_insured_provincia);
    if (other_insured_city !== undefined && other_insured_city !== null && other_insured_city.length > 0) {
        initializeSelect2FromAjax($('select[name="other_owner_city"]'), other_insured_city, other_insured_city.toUpperCase());
    }
}

export function runOtherVehicleAutofill(event) {
    event.preventDefault();
    let other_insured_email = $('input[name="other_insured_email"]').val();
    let other_insured_country = $('select[name="other_owner_country"]').val();
    let other_insured_provincia = $('select[name="other_owner_provincia"]').val();
    let other_insured_city = $('select[name="other_owner_comune"]').val();
    let other_insured_address = $('input[name="other_owner_address"]').val();
    let other_insured_zip = $('input[name="other_owner_cap"]').val();
    let other_insured_comune_istat = $('input[name="other_owner_comune_istat"]').val();
    let other_insured_area = $('input[name="other_owner_area"]').val();

    $('select[name="other_vehicle_country"]').val(other_insured_country).trigger('change');
    $('select[name="other_vehicle_provincia"]').val(other_insured_provincia).trigger('change');
    $('input[name="other_vehicle_address"]').val(other_insured_address);
    $('input[name="other_vehicle_cap"]').val(other_insured_zip);
    $('input[name="other_vehicle_city_istat"]').val(other_insured_comune_istat);
    $('input[name="other_vehicle_area"]').val(other_insured_area);
    $('input[name="other_vehicle_telephone"]').val($('input[name="other_owner_telephone"]').val());
    $('input[name="other_vehicle_email"]').val($('input[name="other_owner_email"]').val());
    initializeSelect2($('select[name="other_vehicle_country"]'), other_insured_country);
    initializeSelect2($('select[name="other_vehicle_provincia"]'), other_insured_provincia);
    if (other_insured_city !== undefined && other_insured_city !== null && other_insured_city.length > 0) {
        initializeSelect2FromAjax($('select[name="other_vehicle_city"]'), other_insured_city, other_insured_city.toUpperCase());
    }
}
